/**
 * @module store/label/actions
 */

// Prevents duplicate parallel requests during page navigations
const inFlight = new Map();

/**
 * @method getLabelTranslations
 * @description
 *
 * Method to get the label trnalsations for given language
 * @param {object} params Object containing lang and baseLang. Lang is the language code for which translations should be fetched.
 * baseLang is the base language code which will be used in case of user preferred language missing
 * @returns {object} Returns label translations object
 */
export function getLabelTranslations({ rootState }, params) {
  const _t = rootState.LAST_UPDATE_TIMESTAMPS['apiLabels'];
  const key = `${params.lang}_${params.baseLang}_${_t}`;

  if (!inFlight.has(key)) {
    inFlight.set(
      key,
      this.$axios.$get('/api/language/label/json', { params: { ...params, _t } }).finally(() => inFlight.delete(key))
    );
  }

  return inFlight.get(key);
}
